import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Container, Section, Eyebrow, Reveal } from "@/components/kit";

const faqs = [
  {
    q: "What exactly counts as a 'qualified' meeting?",
    a: "A meeting where the prospect is ICP-matched, holds relevant authority, has a genuine need, and attends the call — all aligned to the parameters we agree on before launch. If a booked meeting fails any gate, you don't pay for it.",
  },
  {
    q: "How does the pay-for-performance model work?",
    a: "You're billed only for meetings that are qualified, attended, and parameter-aligned. Random calendar bookings, no-shows, and off-profile prospects cost you nothing. We win when you get real pipeline.",
  },
  {
    q: "Which companies is this best suited for?",
    a: "B2B tech and SaaS companies — typically seed through growth-stage — with a defined ICP and an offer that closes through sales conversations. We work best when there's a clear ideal customer to engineer toward.",
  },
  {
    q: "What tools and channels do you use?",
    a: "We orchestrate email, LinkedIn and calling using a modern outbound stack (Apollo, Clay, Instantly, Smartlead, LinkedIn Sales Navigator) integrated with your CRM like HubSpot or Salesforce. We own deliverability and sending infrastructure end to end.",
  },
  {
    q: "How fast can we launch and see meetings?",
    a: "Onboarding, ICP definition and infrastructure warm-up typically take 1–2 weeks. Most clients see their first qualified meetings within 2–4 weeks of launch, scaling from there.",
  },
  {
    q: "Do you replace or work alongside our SDR team?",
    a: "Both models work. Some clients use us as a fully managed SDR-as-a-service layer; others plug us in alongside an existing team to expand coverage and channels without adding headcount.",
  },
];

export const Faq = () => (
  <Section data-testid="faq-section" className="bg-navy-800/30 border-y border-white/10">
    <Container className="grid gap-14 lg:grid-cols-[0.7fr_1.3fr]">
      <div>
        <Eyebrow>Questions</Eyebrow>
        <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
          Answers before
          <br />
          you ask
        </h2>
        <p className="mt-6 text-white/60 leading-relaxed">
          Still unsure? A discovery call is the fastest way to get specifics for your motion.
        </p>
      </div>

      <Reveal>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-white/10"
            >
              <AccordionTrigger className="py-6 text-left font-display text-lg md:text-xl font-medium text-white hover:no-underline hover:text-gold [&[data-state=open]]:text-gold">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 text-white/60 text-base leading-relaxed">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </Container>
  </Section>
);
